import React, { createContext } from 'react';

import { Factory } from 'impermax-sdk';

const FactoryContext = createContext<Factory>(undefined);
export default FactoryContext;
